import React, { useState } from 'react';
import { MdOutlineTextSnippet } from 'react-icons/md';
import { BsPlusLg } from 'react-icons/bs';
import { CgClose } from 'react-icons/cg';
import { useNavigate } from 'react-router-dom';

const ValentinesTAndC = () => {
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      <div className="tAndcContainer">
        <div
          className="accordion-title d-flex justify-content-between align-items-center"
          onClick={() => setIsActive(!isActive)}
        >
          <div className="faq-container">
            <div className="terms-icon-container">
              <MdOutlineTextSnippet className="terms-icon" size={20} color="#040404" style={{ opacity: '0.5' }} />
            </div>
            <span className="termsTitle">Terms & Conditions</span>
          </div>
          <div className="col-1 d-flex justify-content-end">
            <span className="row toggleBtn">
              {isActive ? <CgClose color="#040404" size={20} /> : <BsPlusLg color="#040404" size={20} />}
            </span>
          </div>
        </div>
        {isActive && (
          <div className="accordion-content subText">
            <div>
              <ul className="termAndConditionPoints mt-4">
                <li style={{ color: '#040404' }}>
                  <p>
                    ELIGIBILITY
                    <br />
                    To participate in the Five Years of GoSats campaign, you must fulfil the following{' '}
                    <a style={{ color: '#D1964A' }} onClick={() => navigate('/valentinesTnC')} className="tAndc">
                      read more.
                    </a>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ValentinesTAndC;
